angular.module('leanlaw').directive('llProgress', [function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./views/llProgress.html"),
    scope: {
      percentage: "="
    },
    link: ($scope, element, attrs) => {
      function setWidth() {
        $(element).find(".progress-bar")[0].style.width = $scope.percentage + "%";
      }
      setWidth();
      $scope.$watch("percentage", setWidth);
    }
  };
}]);